import { useCurrentBreakpoint, breakpoints } from '../useCurrentBreakpoint/useCurrentBreakpoint.js';

/**
 * Hook that returns true if the current breakpoint is greater than the specified breakpoint.
 * @param {Breakpoint} breakpoint - The breakpoint to compare against.
 * @returns {boolean} `true` if the current breakpoint is greater than the specified breakpoint, `false` otherwise.
 */
var useGreaterThan = function (breakpoint) {
  var currentBreakpoint = useCurrentBreakpoint();
  return breakpoints[currentBreakpoint] >= breakpoints[breakpoint];
};

export { useGreaterThan };
//# sourceMappingURL=useGreaterThan.js.map
